import { render, staticRenderFns } from "./copyright-block.vue?vue&type=template&id=5ed96912&"
import script from "./copyright-block.vue?vue&type=script&lang=js&"
export * from "./copyright-block.vue?vue&type=script&lang=js&"
import style0 from "./copyright-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed96912')) {
      api.createRecord('5ed96912', component.options)
    } else {
      api.reload('5ed96912', component.options)
    }
    module.hot.accept("./copyright-block.vue?vue&type=template&id=5ed96912&", function () {
      api.rerender('5ed96912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/footer/copyright-block.vue"
export default component.exports